import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Latin-only subset (covers German umlauts/ß): keeps the self-hosted font
// payload small instead of pulling every script's glyphs. Nunito for body
// copy (stays readable at length), Fredoka for headings/buttons/scores —
// a bold rounded "mini-game" display face, see docs/decisions.md.
import "@fontsource/nunito/latin-400.css";
import "@fontsource/nunito/latin-600.css";
import "@fontsource/nunito/latin-700.css";
import "@fontsource/fredoka/latin-500.css";
import "@fontsource/fredoka/latin-600.css";
import "@fontsource/fredoka/latin-700.css";
import "./styles/tokens.css";
import { App } from "./App.js";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element missing");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
